import React from 'react';

import {
  ZapType,
  ZapBlock,
  KindType,
  KindDisplayNameType,
  Container,
} from '@zapier/product-get-help';

import { useFormContext } from 'app/get-help/contexts/FormContext';
import { withAutoScroll } from 'app/get-help/components/AutoScroll';

type ZapProps = {
  actions: {
    answer: (data: any) => void;
    unanswer: () => void;
  };
  data: any;
  disableIncidents: boolean;
  instructions: string;
  isCurrent: boolean;
  state: string;
  title: string;
  kind: KindType[];
  kindDisplayName: KindDisplayNameType;
};

const Zap = (props: ZapProps) => {
  const {
    actions: { answer, unanswer },
    data,
    disableIncidents,
    instructions,
    isCurrent,
    state,
    title,
    kind,
    kindDisplayName,
  } = props;

  const { account, setZap, size } = useFormContext();

  // We only use this block when we have an account
  const accountId = String(account?.id);

  const zapBlockState =
    state === 'confirm' ? state : isCurrent ? 'open' : 'closed';

  const onSelect = (zap: ZapType | null) => {
    answer(zap);
    setZap(zap || undefined);
  };

  return (
    <Container paddingBottom={20}>
      <ZapBlock
        accountId={accountId}
        disableIncidents={disableIncidents}
        kind={kind}
        kindDisplayName={kindDisplayName}
        onClickEdit={unanswer}
        onSelect={onSelect}
        selectedZap={data}
        size={size}
        state={zapBlockState}
        title={title}
      >
        {instructions}
      </ZapBlock>
    </Container>
  );
};

export default withAutoScroll(Zap);
